import './index.css'
import {useFieldArray, useFormContext, Controller, Control} from "react-hook-form";
import { ReactComponent as RiDeleteBinLine } from '@/assets/icons/ri-delete-bin-line.svg'
import { ReactComponent as BadmintonCourt } from '@/assets/icons/badminton-court.svg'
import { ReactComponent as RiAddLine } from "@/assets/icons/ri-add-line.svg";
import Input from "@/components/common/Input";
import Button from "@/components/common/Button";
import GenericSelect from "@/components/common/GenericSelect";

const Court = () => {
  const { control } = useFormContext()
  const courtsField = useFieldArray({
    keyName: 'generatedId',
    name: 'courts'
  })
  const pricesField = useFieldArray({
    name: 'prices',
    keyName: 'generatedId'
  })
  const mappedCourts = courtsField.fields as CourtVO[]
  const mappedPrices = pricesField.fields as PriceVO[]
  
  const handleClickAddCourt = () => {
    const newCourt = {
      code: '',
      venue_price_name: ''
    }
    courtsField.append(newCourt)
  }
  
  const getPriceIdSelectValue = (prices, field) => {
    const found = prices?.find(p => p.id === field.value)
    
    return found ? {
      value: found.id,
      label: found.name
    } : null
  }
  
  const getPriceNameSelectValue = (prices, field) => {
    const found = prices?.find(p => p.name === field.value)
    
    return found ? {
      value: found.name,
      label: found.name
    } : null
  }
  
  const getPriceIdOptions = (prices: Price[]) => prices?.map((p) => ({
    value: p.id,
    label: p.name
  }))
  
  const getPriceNameOptions = (prices: Price[]) => prices?.map((p) => ({
    value: p.name,
    label: p.name
  }))
  
  const renderCourtRows = (courts: CourtVO[], prices: Price[], con: Control, remove: Function) =>
    courts.map((c, index) => (
      <div key={c.generatedId} className="flex w-full gap-4 justify-start items-center">
        <BadmintonCourt />
        <div className="flex-grow flex-1">
          <Input
            expanded
            name={`courts.${index}.code`}
            type="text"
            placeholder="Court Code"
            validationSchema={{required: true, maxLength: 5}}/>
        </div>
        <div className="flex-grow flex-1">
          {
            c.venue_price_id ?
              <Controller
                control={con}
                name={`courts.${index}.venue_price_id`}
                render={({field}) =>
                  <GenericSelect
                    {...field}
                    onChange={(val) => {
                      field.onChange(val.value)
                    }}
                    value={getPriceIdSelectValue(prices, field)}
                    placeholder="Choose Pricing Class"
                    options={getPriceIdOptions(prices)}
                  />
                }
              />
              :
              <Controller
                control={con}
                name={`courts.${index}.venue_price_name`}
                render={({field}) =>
                  <GenericSelect
                    {...field}
                    onChange={(val) => {
                      field.onChange(val.value)
                    }}
                    value={getPriceNameSelectValue(prices, field)}
                    placeholder="Choose Pricing Class"
                    options={getPriceNameOptions(prices)}
                  />
                }
              />
          }
        </div>
        <button
          onClick={() => {
            remove(index)
          }}
          type="button"
          className="text-red-primary">
          <RiDeleteBinLine/>
        </button>
      </div>
    ))
  
  return (
    <div className="card-base">
      <div className="text-jlg mb-7">Court</div>
      <div className="grid auto-rows-auto grid-cols-1 gap-5">
        {renderCourtRows(mappedCourts, mappedPrices, control, courtsField.remove)}
      </div>
      <div>
        <Button
          onClick={handleClickAddCourt}
          type="button"
          variant="tertierry"
          className="whitespace-nowrap flex gap-2 pl-4 py-2 justify-center items-center mt-5 p-0 pl-0 py-0">
          <div className="w-[18px] text-red-primary">
            <RiAddLine/>
          </div>
          <span className="text-jsm">Add Court</span>
        </Button>
      </div>
    </div>
  )
}

export default Court;